export const MENU_HOME = 'New OLP Home Page';
export const MENU_LOVE_PROMISE = 'Love Promise Commitment Awards';
export const MENU_REPORTING = 'New OLP (Field Only)';
export const MENU_SCORES = 'Scores';

export const MENU_SUPPORT = 'Support Docs';
export const MENU_OLP_LEGACY = 'OLP';
export const MENU_OLP_LEGACY_EXTERNAL = 'OLP';

// Sub menu of Reporting
export const MENU_RP_JUST_IN_TIME = 'Just-In-Time';
export const MENU_RP_COMMENT = 'Comments';
export const MENU_RP_MY_REPORTS = 'My Reports';
export const MENU_SCORES_SNAPSHOT = 'Snapshot';
export const MENU_SCORES_TREND = 'Trend';

// Sub Menu of LED
export const MENU_LED = 'Love Encore Delivery (LED)';
export const MENU_LED_JIT = 'LED Just-in-Time';
export const MENU_LED_RETAILER_PERFORMANCE = 'LED Retailer Performance (Field Only)';
export const MENU_LED_DELIVERY_SPECIALIST = 'Delivery Specialist';

// Sub menu of Love Promise
export const MENU_LP_HOME_PAGE = 'LPCCA Home Page';
export const MENU_LP_RETAILER_SUMMARY_REPORT = 'Retailer Summary Report';
export const MENU_LP_CORPORATE_REPORT_DOWNLOAD = 'Corporate Report Download';
